(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentWorkItem', DocumentWorkItem);

    DocumentWorkItem.$inject = ['$resource', 'DateUtils'];

    function DocumentWorkItem ($resource, DateUtils) {
        var resourceUrl =  'api/document-work-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
